import React, { useMemo } from 'react';
import { View, Text, TextInput, Pressable } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { GROUP_NAME_MAX_LENGTH } from '../../../src/friends/constants/groupName';
import { WORLD_CUP_GROUP_DESCRIPTION_MAX_LENGTH } from '../../../src/worldcup/worldcup.constants';
import {
  CREATE_WORLD_CUP_GROUP_COPY,
  NAME_SUGGESTIONS,
} from './CreateWorldCupGroupScreen.constants';
import { getCreateWorldCupGroupStep1FormStyles } from './CreateWorldCupGroupStep1Form.styles';

export type CreateWorldCupGroupStep1FormProps = {
  theme: Theme;
  name: string;
  description: string;
  isSubmitting: boolean;
  onChangeName: (text: string) => void;
  onChangeDescription: (text: string) => void;
};

export const CreateWorldCupGroupStep1Form: React.FC<CreateWorldCupGroupStep1FormProps> = ({
  theme,
  name,
  description,
  isSubmitting,
  onChangeName,
  onChangeDescription,
}) => {
  const styles = useMemo(() => getCreateWorldCupGroupStep1FormStyles(theme), [theme]);

  return (
    <View style={styles.root}>
      {/* 01 — SQUAD NAME */}
      <Text style={styles.sectionLabel}>{CREATE_WORLD_CUP_GROUP_COPY.SECTION_NAME}</Text>
      <View style={styles.nameInputWrap}>
        <TextInput
          value={name}
          onChangeText={onChangeName}
          placeholder={CREATE_WORLD_CUP_GROUP_COPY.NAME_PLACEHOLDER}
          placeholderTextColor={theme.gray[400]}
          style={styles.nameInput}
          editable={!isSubmitting}
          maxLength={GROUP_NAME_MAX_LENGTH}
          autoCapitalize="words"
          testID="create-world-cup-group-name"
        />
        <Text style={styles.charCountInline}>
          {name.length}/{GROUP_NAME_MAX_LENGTH}
        </Text>
      </View>
      <View style={styles.suggestionRow}>
        {NAME_SUGGESTIONS.map((s) => (
          <Pressable
            key={s}
            style={styles.suggestionChip}
            onPress={() => onChangeName(s)}
            disabled={isSubmitting}
          >
            <Text style={styles.suggestionChipText}>{s}</Text>
          </Pressable>
        ))}
      </View>

      {/* 02 — TAGLINE · OPTIONAL */}
      <Text style={styles.sectionLabel}>{CREATE_WORLD_CUP_GROUP_COPY.SECTION_TAGLINE}</Text>
      <View style={styles.taglineInputWrap}>
        <TextInput
          value={description}
          onChangeText={onChangeDescription}
          placeholder="Big talk, bigger picks"
          placeholderTextColor={theme.gray[400]}
          style={styles.taglineInput}
          editable={!isSubmitting}
          maxLength={WORLD_CUP_GROUP_DESCRIPTION_MAX_LENGTH}
          multiline
          numberOfLines={4}
          testID="create-world-cup-group-description"
        />
        <Text style={styles.taglineCharCount}>
          {description.length}/{WORLD_CUP_GROUP_DESCRIPTION_MAX_LENGTH}
        </Text>
      </View>
    </View>
  );
};
